import repositories from '../api/RepositoryFactory';

export default (function () {
  const asahiWeeklyDigitalBanner = document.getElementById("asahiWeeklyDigitalBanner");
  if (!asahiWeeklyDigitalBanner) return;

  asahiWeeklyDigitalBanner.addEventListener("click", async (event) => {
    event.preventDefault();

    const url = asahiWeeklyDigitalBanner.getAttribute("href");

    try {
      const pagePath = window.location.pathname;

      window.location.href = url;
      await repositories.asahiAccessLogRepository.createAsahiAccessLog(pagePath);
    } catch (error) {
      console.error("エラー:", error);
    }

  });

})();
